import React from 'react';
import PropTypes from 'prop-types';

import LinearProgress from 'material-ui/LinearProgress';
import DetailView from '../Common/DetailView';
import { List } from 'material-ui/List';
import StatementListItem from '../LearningRecordStore/StatementListItem';


import DeleteIcon from 'material-ui/svg-icons/action/delete';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import InfoIcon from 'material-ui/svg-icons/action/info';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import EnrolmentIcon from 'material-ui/svg-icons/action/check-circle';
import CourseStore from '../../stores/CourseStore';
import CourseMediaStore from '../../stores/CourseMediaStore';
import CourseActivityStore from '../../stores/CourseActivityStore';
import ActivityStore from '../../stores/ActivityStore';
import CourseActions from '../../actions/CourseActionCreator';


import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';

import LRS from '../../utils/LRS.js';
import { withId } from '../Common/Decorators';

const style = {
    list: {
        paddingBottom: 0,
    },
};

const getMenuItems = (id) => [
    {
        link: `/dashboard/course/${id}`,
        icon: <InfoIcon />,
        label: 'Preview',
    },
    {
        type:'divider'
    },
    {
        link: `/dashboard/course/${id}/enrolments`,
        icon: <EnrolmentIcon />,
        label: 'Enrolments',
        condition: {
            roles: [ROLES.MANAGER]
        }
    },
    {
        type: 'divider'
    },
    {
        link: `/dashboard/course/${id}/settings`,
        icon: <SettingsIcon />,
        label: 'Settings',
        condition: {
            roles: [ROLES.ADMIN]
        }
    }
];

const CourseActivity = React.createClass({

    getInitialState() {
        return {
            details: {
                name: '',
                description: '',
                outline: '',
                instruction: '',
                url: '',
                type: '',
                courseStatus: '',
                code: '',
                capacity: '',
            },
            mediaId: '',
            courseTinCan: '',
            tinCanList: [],
            activities: (<div><LinearProgress mode="indeterminate" /></div>),
            actions: [],
            links: {
                back: `/dashboard/course/${this.props.id}`,
                edit: '',

            }
        }
    },

    componentDidMount() {
        this.setState({actions: buildContextMenu(getMenuItems(this.props.id), this.context.auth)});
        ActivityStore.addChangeListener(this.onActivityChange);
        CourseMediaStore.addChangeListener(this.onMediaInfoChange);
        CourseActivityStore.addChangeListener(this.onTinCanListChange);
        CourseStore.addChangeListener(this.onChange);
        CourseActions.getById(this.props.id);
    },

    componentWillUnmount() {
        CourseStore.removeChangeListener(this.onChange);
        CourseMediaStore.removeChangeListener(this.onMediaInfoChange);
        CourseActivityStore.removeChangeListener(this.onTinCanListChange);
        ActivityStore.removeChangeListener(this.onActivityChange);
    },

    render() {
        return (

            <DetailView
                title='Activity'
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-list-wrapper">
                    <List style={style.list} className='cent-list'>
                        {this.state.activities}
                    </List>
                </div>
            </DetailView>
        );
    },

    onChange() {
        if (this.state.details.id === undefined) {
            const course = CourseStore.getById(this.props.id);

            if (course !== undefined) {
                this.setState({details: course});
                if (course.code !== this.state.mediaId) {
                    CourseActions.getMediaInfo(course.code);
                }
            }
        }
    },

    onMediaInfoChange() {
        const mediaInfo = CourseMediaStore.getById(this.state.details.code);
        if (mediaInfo !== undefined) {
            const state = {mediaId: mediaInfo.id};
            if (mediaInfo.tinCanActivityId !== undefined && mediaInfo.tinCanActivityId !== '') {
                state.courseTinCan = mediaInfo.tinCanActivityId;
                LRS.getCourseActivity(mediaInfo.tinCanActivityId, !this.context.auth.isAdmin() && this.context.auth.identity.id);
            } else {
                CourseActions.getTinCanList(this.state.details.code);
            }
            this.setState(state);
        }
    },

    onTinCanListChange() {
        const tinCanList = CourseActivityStore.getTinCanList(this.state.details.code);
        if (tinCanList !== undefined) {
            const list = tinCanList.map(({tinCanId}) => tinCanId);
            list.forEach(tinCanId => LRS.findByRegistrationId(attempt.tinCanId));
            this.setState({tinCanList: list});
        }
    },

    getActivities() {
        if (this.state.courseTinCan !== undefined && this.state.courseTinCan !== '') {
            return ActivityStore.getByCourse(this.state.courseTinCan, !this.context.auth.isAdmin() && this.context.auth.identity.id);
        } else {
            return ActivityStore.getByRegistration(this.state.tinCanList);
        }
    },

    onActivityChange() {
        const activities = this.getActivities();

        if (activities !== undefined && activities.length > 0) {
            const entries = activities
                .filter((attempt) => {
                    if (attempt !== undefined) {
                        const verb = attempt.verb.id.split('/').pop();
                        return verb === 'passed' || verb === 'failed';
                    }
                    return false;
                })
                .sort((a, b) => b.datetime - a.datetime)
                .map((attempt) => !!attempt && <StatementListItem statement={attempt} key={attempt.id} />);
            this.setState({activities: entries});
        }
    },
});

CourseActivity.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(CourseActivity);
